function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from './Box';
const Link = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Box, _extends({
  ref: ref,
  as: props.to ? RouterLink : 'a',
  variant: "link"
}, props)));
Link.displayName = 'Link';
export default Link;